import { render, staticRenderFns } from "./i-wysiwyg2.vue?vue&type=template&id=43b48d00&scoped=true&"
import script from "./i-wysiwyg2.vue?vue&type=script&lang=js&"
export * from "./i-wysiwyg2.vue?vue&type=script&lang=js&"
import style0 from "./i-wysiwyg2.vue?vue&type=style&index=0&id=43b48d00&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43b48d00",
  null
  
)

export default component.exports